/**
 * Cross-link list for the Austin product landing pages.
 * Rendered as a sibling callout on every Austin product page so Google
 * sees a tight internal-link cluster around "Austin" + product.
 */
export interface AustinSibling {
  to: string;
  label: string;
  blurb: string;
}

export const AUSTIN_SIBLINGS: AustinSibling[] = [
  {
    to: "/patio-covers/in/austin",
    label: "Patio Covers in Austin",
    blurb: "Custom welded patio covers — attached, freestanding, gable & flat designs.",
  },
  {
    to: "/aluminum-patio-covers/in/austin",
    label: "Aluminum Patio Covers in Austin",
    blurb: "Welded aluminum frames — no rust, no rot, 20+ year lifespan.",
  },
  {
    to: "/insulated-patio-covers/in/austin",
    label: "Insulated Patio Covers in Austin",
    blurb: "Snap-N-Lock style insulated roof panels for true heat blocking.",
  },
  {
    to: "/louvered-patio-covers/in/austin",
    label: "Louvered Patio Covers in Austin",
    blurb: "Adjustable louvered roofs that open, close and shed rain on command.",
  },
  {
    to: "/patio-enclosures/in/austin",
    label: "Patio Enclosures in Austin",
    blurb: "Drop curtains, wind walls and screened enclosures for year-round patios.",
  },
];
